if (!customElements.get('korvia-story-steps')) {
  customElements.define('korvia-story-steps', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.steps = [...this.querySelectorAll('.kp-step')];
      if (!this.steps.length) return;
      this.index = 0;
      this.elapsed = 0;
      this.visible = false;
      this.hovered = false;
      this.focused = false;
      this.duration = Math.max(5000, Number(this.dataset.duration) || 7000);
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.playing = this.dataset.autoplay === 'true' && !this.motion.matches && !window.Shopify?.designMode;
      this.play = this.querySelector('.kp-steps-play');
      this.count = this.querySelector('.kp-steps-count');
      this.classList.add('is-enhanced');
      this.querySelector('.kp-steps-controls').hidden = this.steps.length < 2;
      this.steps.forEach((step, index) => {
        step.querySelector('button').addEventListener('click', () => {
          this.playing = false;
          this.select(index);
          this.sync();
        }, options);
      });
      this.play.addEventListener('click', () => {
        this.playing = !this.playing;
        this.sync();
      }, options);
      this.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { this.hovered = true; this.sync(); } }, options);
      this.addEventListener('pointerleave', () => { this.hovered = false; this.sync(); }, options);
      this.addEventListener('focusin', event => { this.focused = event.target !== this.play; this.sync(); }, options);
      this.addEventListener('focusout', () => queueMicrotask(() => {
        this.focused = this.contains(document.activeElement) && document.activeElement !== this.play;
        this.sync();
      }), options);
      document.addEventListener('visibilitychange', () => this.sync(), options);
      this.motion.addEventListener('change', () => { if (this.motion.matches) this.playing = false; this.sync(); }, options);
      document.addEventListener('shopify:block:select', event => {
        const index = this.steps.findIndex(step => step.dataset.blockId === event.detail?.blockId);
        if (index >= 0) { this.playing = false; this.select(index); this.sync(); }
      }, options);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.sync();
      }, { threshold: 0.35 });
      this.observer.observe(this);
      this.select(0);
      this.sync();
    }
    select(index) {
      this.index = index;
      this.elapsed = 0;
      this.style.setProperty('--step-progress', '0');
      this.steps.forEach((step, i) => {
        const active = i === index;
        step.classList.toggle('is-active', active);
        step.querySelector('button').setAttribute('aria-expanded', String(active));
        const panel = step.querySelector('.kp-step-panel');
        panel.inert = !active;
        panel.setAttribute('aria-hidden', String(!active));
      });
      this.count.textContent = `${String(index + 1).padStart(2, '0')} / ${String(this.steps.length).padStart(2, '0')}`;
    }
    sync() {
      cancelAnimationFrame(this.frame);
      this.play.textContent = this.playing ? 'Pausar' : 'Reproducir';
      this.play.setAttribute('aria-label', this.playing ? 'Pausar etapas' : 'Reproducir etapas');
      if (!this.controller || !this.playing || !this.visible || this.hovered || this.focused || document.hidden || this.steps.length < 2) return;
      this.last = performance.now();
      const tick = now => {
        this.elapsed += Math.min(now - this.last, 100);
        this.last = now;
        if (this.elapsed >= this.duration) this.select((this.index + 1) % this.steps.length);
        this.style.setProperty('--step-progress', String(this.elapsed / this.duration));
        this.frame = requestAnimationFrame(tick);
      };
      this.frame = requestAnimationFrame(tick);
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.observer?.disconnect();
      this.controller?.abort();
      this.controller = null;
    }
  });
}
